import { call, put } from "redux-saga/effects";
import { setProductDetails } from "../actions";
import axios from "axios";

import Cookies from 'js-cookie'



const requestGetProductDetails = (productId) => {
    return axios.request({
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/products/get-product-details?productId=${productId}`
    })
}

export function* handleGetProductDetails(action) {
    const { productId, history } = action.payload;
    try {
        const response = yield call(requestGetProductDetails, productId);
        const product = response.data;
        if (product.status == undefined) {
            history.push('/404')
        } else {
            console.log("Axios response for product details: ", response.data);
            yield put(setProductDetails(response.data));
        }
    }
    catch (error) {
        history.push('/404')
        console.log("big error: ", error);
    }
}